import {
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Permission } from '../interfaces/permission.pojo';
import { UserData } from '../services/state/user-data';

@Directive({
  selector: '[hasPermission]',
})
export class HasPermission {
  private userStore = inject(UserData);
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);

  readonly hasPermission = input.required<Permission>();

  constructor() {
    effect(() => {
      this.updateView();
    });
  }

  private updateView(): void {
    const permission = this.hasPermission();
    const hasAccess = this.userStore.hasPermission(permission);

    if (hasAccess) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
